import { Link, useLocation, useNavigate } from "react-router-dom";
import { getListeSecteur } from "../../data/params/secteur";
import { getListeStatut } from "../../data/params/statut";
import "./dossiers.css";
import { FolderOpenOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Input,
  message,
  Select,
  Space,
  Table,
  Tag,
  Tooltip,
} from "antd";
import { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PageLabel from "../../components/common/PageLabel/PageLabel";
import { FormContainer } from "../../components/common/common.components";
import FormLabel from "../../components/common/Form/FormLabel";
import SearchRow from "../../components/common/SearchRow";
import TableTitle from "../../components/common/TableTitle";
import { faEye, faFileExport, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { HStack } from "@chakra-ui/react";
import * as XLSX from "xlsx";

const ExercicesCours = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [filtersItems, setFiltersItems] = useState([]);
  const [statuts, setStatuts] = useState([]);
  const [secteurs, setSecteurs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paramsRecherche, setParamsRecherche] = useState({
    infosClient: "",
    secteur_id: "",
    statut_id: "",
  });
  const user = useSelector((state) => state.user);
  const isAdmin = user.libelleProfil === "Admin";

  const [clientsDossiers, setClientsDossiers] = useState(
    location?.state?.dossiers.filter((item) => item?.isCloture !== true) || [],
  );

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      filtersItems,
    },
  });

  useEffect(() => {
    fetchStatuts();
    fetchSecteurs();
  }, []);

  useEffect(() => {
    if (clientsDossiers.length) {
      setLoading(true);
      setFiltersItems(clientsDossiers);
      setLoading(false);
    }
  }, [clientsDossiers]);

  const fetchSecteurs = async () => {
    setLoading(true);
    const res = await getListeSecteur();
    setSecteurs(res?.result);
    setLoading(false);
  };

  const fetchStatuts = async () => {
    setLoading(true);
    const res = await getListeStatut();
    setStatuts(res?.result);
    setLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });

    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setFiltersItems([]);
    }
  };

  const handleExport = () => {
    try {
      const csvData = filtersItems.map((item) => ({
        // Informations générales du client
        Sigle: item?.client?.sigle,
        Dénomination: item?.client?.denomination,
        "Statut juridique": item?.client?.StatusJuridique?.libelle,
        "Secteur d'activité": item?.client?.SecteurActivite?.libelle,
        "Numéro R.C.C.M": item?.client?.numero_rccm,
        "Numéro compte contribuable (CC)": item?.client?.numero_cc,
        "Centre impôts": item?.client?.centre_impots,
        "Numéro CNPS employeur": item?.client?.numero_cnps_employeur,
        "Numéro agrément": item?.client?.numero_agrement,
        "Adresse géographique": item?.client?.localisation,
        "Adresse postale": item?.client?.adresse_postale,
        "Téléphone 1": item?.client?.cel1,
        "Téléphone 2": item?.client?.cel2,
        Email: item?.client?.email,
        "Site internet": item?.client?.site_internet,
        "Actionnaire majoritaire": item?.client?.actionnaire_majoritaire,
        "Nom du dirigeant": item?.client?.nom_dirigeant,
        "Expert comptable": item?.client?.expert_comptable,
        "Conseil juridique": item?.client?.conseil_juridique,
        "Co-Commissaire aux Comptes": item?.client?.commissaire_compte,
        "Associé signataire": item?.client?.associe_signataire,

        // Informations sur la dernière mission
        "Dernière mission": item?.mission?.mission,
        "Année dernière mission": item?.mission?.annee,
        "Mission clôturée": item?.mission?.isCloture ? "Oui" : "Non",
        "Mission clôturée provisoirement": item?.mission?.isClotureProvisoire
          ? "Oui"
          : "Non",
        "Lettre de mission signée": item?.mission?.lettre_mission
          ? "Oui"
          : "Non",
        "Commentaire clôture": item?.mission?.commentCloture || "N/A",
        "Nom du manager": `${item?.nom_manager || ""} ${
          item?.prenom_manager || ""
        }`.trim(),
      }));

      const worksheet = XLSX.utils.json_to_sheet(csvData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Actes");

      XLSX.writeFile(workbook, "liste_dossiers_lea.xlsx");

      message.success("Export réussi");
    } catch (error) {
      console.error(error);
      message.error("Erreur lors de l'export");
    }
  };

  const exercicesUserColumns = [
    {
      title: <TableTitle>#</TableTitle>,
      width: 50,
      render: (value, record, index) => {
        return <>{index + 1}</>;
      },
    },
    {
      title: <TableTitle>Exercice</TableTitle>,
      dataIndex: "exercice",
      key: "exercice",
      render: (value, record, index) => {
        return (
          <>
            <div className="d-flex align-items-center">
              <div className="symbol symbol-45px me-5">
                <FolderOpenOutlined
                  style={{
                    fontSize: "3rem",
                    color: "rgb(250, 152, 28)",
                  }}
                />
              </div>
              <div className="d-flex justify-content-start flex-column">
                <Link
                  className="text-gray-800 text-hover-primary"
                  to={`/clients/mission/exploitation/${record?.exercice_id}`}
                  state={{
                    record: record?.client,
                    mission: record?.mission,
                  }}
                >
                  <span className="text-dark fw-bolder text-hover-primary fs-6">
                    {record?.mission_name || ""} - {record?.mission_annee || ""}
                  </span>
                  <span className="text-muted fw-bold text-muted d-block fs-9 text-uppercase">
                    <Tag>{record?.sigle_client}</Tag> | {record?.status_client}
                  </span>
                </Link>
              </div>
            </div>
          </>
        );
      },
    },
    {
      title: <TableTitle>Secteur juridique</TableTitle>,
      dataIndex: "secteur_juridique",
      key: "secteur_juridique",
      render: (value, record, index) => {
        return (
          <>
            <Space>
              <span className="text-black fw-bold d-block fs-5 text-uppercase">
                {record?.secteur_client}
              </span>
            </Space>
          </>
        );
      },
    },
    {
      title: <TableTitle>Manager</TableTitle>,
      dataIndex: "manager",
      key: "manager",
      render: (value, record, index) => {
        return (
          <>
            <Space>
              <div className="fs-2 text-warning pe-2">
                <FontAwesomeIcon icon={faUser} />
              </div>
              <span className="text-dark fw-bolder text-hover-primary d-block fs-5 text-uppercase">
                {record?.nom_manager
                  ? `${record?.nom_manager} ${
                      record?.prenom_manager && record?.prenom_manager
                    }`
                  : ""}
              </span>
            </Space>
          </>
        );
      },
    },
    {
      title: <TableTitle>Statut</TableTitle>,
      dataIndex: "status",
      key: "status",
      render: (value, record, index) => {
        return (
          <>
            {!record?.isCloture ? (
              record?.isLettreMission === 0 && record?.mission?.etat === 1 ? (
                <Tag color="yellow">En attente</Tag>
              ) : (
                <Tag color="blue">En cours</Tag>
              )
            ) : (
              <Tag color="green">Clôturé</Tag>
            )}
          </>
        );
      },
    },
    /* {
      title: <TableTitle>Progression</TableTitle>,
      dataIndex: "progression",
      key: "progression",
      render: (value, record, index) => {
        return (
          <div className="d-flex flex-column w-100 me-2">
            <div className="d-flex flex-stack mb-2">
              <span className="text-muted me-2 fs-7 fw-bold">
                {record?.isCloture ? 100 : record?.progression}
              </span>
            </div>
            <div className="progress h-6px w-100">
              <div
                className={`progress-bar bg-${record?.color}`}
                role="progressbar"
                style={{
                  width: `${record?.isCloture ? 100 : record?.progression}%`,
                }}
                aria-valuenow="50"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>
        );
      },
    }, */
    {
      title: <TableTitle>Actions</TableTitle>,
      dataIndex: "actions",
      align: "right",
      width: 100,
      key: "actions",
      render: (value, record, index) => {
        return (
          <Space>
            <Tooltip title="Consulter le sommaire">
              <Button
                type="primary"
                icon={<FontAwesomeIcon icon={faEye} />}
                onClick={() => {
                  navigate(
                    `/clients/mission/exploitation/${record?.exercice_id}`,
                    {
                      state: {
                        record: record?.client,
                        mission: record?.mission,
                      },
                    },
                  );
                }}
              />
            </Tooltip>
          </Space>
        );
      },
    },
  ];

  const handleSearch = () => {
    setLoading(true);
    const timeoutId = setTimeout(() => {
      const filtereds = clientsDossiers.filter(
        (dossier) =>
          // Vérifier si infosClient est dans sigle_client ou mission_name
          (dossier?.sigle_client
            ?.toLowerCase()
            ?.includes(paramsRecherche.infosClient.toLowerCase()) ||
            dossier?.mission_name
              ?.toLowerCase()
              ?.includes(paramsRecherche.infosClient.toLowerCase())) &&
          // Filtrer par secteur_id si renseigné
          (paramsRecherche.secteur_id === "" ||
            dossier?.client?.secteur_id ===
              Number(paramsRecherche.secteur_id)) &&
          // Filtrer par statut_id si renseigné
          (paramsRecherche.statut_id === "" ||
            dossier?.client?.statut_id === Number(paramsRecherche.statut_id)),
      );
      setFiltersItems(filtereds);
      setLoading(false);
      return () => clearTimeout(timeoutId);
    }, 1000);
  };

  const handleReset = () => {
    setLoading(true);
    setParamsRecherche({
      infosClient: "",
      secteur_id: "",
      statut_id: "",
    });
    setFiltersItems(clientsDossiers);
    setLoading(false);
  };

  return (
    <Fragment>
      <HStack justifyContent="space-between" alignItems="center">
        <PageLabel label="Exercices en cours" />
      </HStack>
      <SearchRow
        handleSearch={handleSearch}
        handleReset={handleReset}
        loading={loading}
      >
        <Col span={8}>
          <FormLabel label="Mission/Client" />
          <Input
            style={{ width: "100%" }}
            size="large"
            placeholder="Mission ou client"
            value={paramsRecherche.infosClient}
            onChange={(e) =>
              setParamsRecherche({
                ...paramsRecherche,
                infosClient: e.target.value,
              })
            }
          />
        </Col>
        <Col span={8}>
          <FormLabel label="Statut juridique" />
          <Select
            placeholder="Staut juridique"
            size="large"
            style={{ width: "100%" }}
            value={paramsRecherche.statut_id}
            onSelect={(value) =>
              setParamsRecherche({ ...paramsRecherche, statut_id: value })
            }
            options={
              statuts?.map((statut) => ({
                value: statut?.id,
                label: statut?.libelle,
              })) || []
            }
          />
        </Col>
        <Col span={8}>
          <FormLabel label="Secteur d'activité" />
          <Select
            placeholder="Secteur d'activité"
            size="large"
            style={{ width: "100%" }}
            value={paramsRecherche.secteur_id}
            onSelect={(value) =>
              setParamsRecherche({ ...paramsRecherche, secteur_id: value })
            }
            options={
              secteurs?.map((secteur) => ({
                value: secteur?.id,
                label: secteur?.libelle,
              })) || []
            }
          />
        </Col>
      </SearchRow>
      <Space className="d-flex justify-content-end pt-4">
        <Button
          type="primary"
          icon={<FontAwesomeIcon icon={faFileExport} />}
          onClick={handleExport}
        >
          Exporter
        </Button>
      </Space>

      <FormContainer>
        <div className="w-100">
          <div className="py-4">
            <div className="table-responsive">
              <Table
                columns={exercicesUserColumns}
                rowKey={(record) => record.id}
                dataSource={filtersItems}
                pagination={tableParams.pagination}
                loading={loading}
                onChange={handleTableChange}
              />
            </div>
          </div>
        </div>
      </FormContainer>
    </Fragment>
  );
};

export default ExercicesCours;
